<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-wechat-list-dialog"
  >
    <wechat-list-form
      :form-data="formData"
      ref="outform"
      @submit="submit"
    ></wechat-list-form>
  </sliderBarDialogShell>
</template>

<script>
import wechatListForm from "@/components/wechat/wechat-list/wechatListForm";
import {editWechat} from "@/api/wechat/wechat-list";

export default {
  name: "editDialog",
  components: {
    wechatListForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    formData:{
      type: Object,
      default(){
        return {}
      }
    }
  },
  watch:{
    dialogShow(newValue){
      if(newValue && this.formData.id){
        setTimeout(() => {
          this.$refs.outform && this.$refs.outform.assigen(this.formData);
        },200);
      }
    },
  },
  data() {
    return {
      title: '编辑微信列表',
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form,
      }
      editWechat(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          this.$emit('edit-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-wechat-list-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
